export default __webpack_public_path__ + "static/media/chestOpen.e87a5dae.mp3";